import { render, staticRenderFns } from "./CreatedReservation.vue?vue&type=template&id=54f49501"
import script from "./CreatedReservation.vue?vue&type=script&lang=js"
export * from "./CreatedReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports